import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { TranslationDomainService } from '@app/translation/domain/translation-domain.service';
import { AuthDomainService } from '@app/auth/domain/auth-domain.service';

@Injectable({ providedIn: 'root' })
export class DefaultTranslationResolver implements Resolve<string> {
  private readonly DEFAULT_LANGUAGE = 'en';

  constructor(
    private authDomainService: AuthDomainService,
    private translationDomainService: TranslationDomainService,
  ) {}

  resolve(): string {
    const userLanguage = this.authDomainService.getStorageAuthData()?.language;
    if (userLanguage) {
      this.activateLanguage(userLanguage);
      return userLanguage;
    }

    const browserLanguage = this.translationDomainService.getBrowserLanguage();
    if (browserLanguage && this.translationDomainService.isLanguageSupported(browserLanguage)) {
      this.activateLanguage(browserLanguage);
      return browserLanguage;
    }

    this.activateLanguage(this.DEFAULT_LANGUAGE);
    return this.DEFAULT_LANGUAGE;
  }

  private activateLanguage(language: string): void {
    if (language !== this.translationDomainService.getActiveLanguage()) {
      this.translationDomainService.setActiveLanguage(language);
    }
  }
}
